import {Injectable} from "@angular/core";
import {AngularFirestore} from "@angular/fire/firestore";
import {from, Observable} from "rxjs";
import {catchError, map, tap} from "rxjs/operators";
import {Storage} from "@ionic/storage";

const ACK_KEY='vm-app-ack';

@Injectable()
export class AcknowledgmentsService {

  constructor(
    private firestore: AngularFirestore,
    private storage: Storage
  ) {}

  get(): Observable<string> {
    let data = this.firestore.collection('config')
      .doc('acknowledgments')
      .get()
      .pipe(
        map(doc => doc.data().text),
        tap( text =>  {this.storage.set(ACK_KEY, text)}),
        catchError( () => {
          return from(this.storage.get(ACK_KEY));
        })
      );
   return data;

  }

  save(text): Promise<void> {
    return this.firestore.collection('config').doc('acknowledgments').set({
      text: text
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/acknowledgments.service.ts